<template>
  <div v-if="job && currentNode">
    <el-button v-for="action in currentNode.actions" :key="action.id" no="actionName" type="primary" @click="()=>handleClick(action)">{{ action.actionName }}</el-button>
  </div>
</template>

<script>
import { getWorkFlow, actionProcess } from '@/api/workflow'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'Workflow',
  props: {
    documentConfigName: {
      type: String,
      default: () => ''
    },
    stateKey: {
      type: String,
      default: () => ''
    },
    stateValue: {
      type: String,
      default: () => ''
    },
    job: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      workflowData: null,
      loading: null
    }
  },
  computed: {
    processNode() {
      return this.workflowData ? this.workflowData.processNodes : []
    },
    roleUuids() {
      return this.$store.state.user.roleIds.map(role => role.roleUuid)
    },
    currentNode() {
      const { roleUuids, job, stateKey } = this
      return this.processNode.find(node => {
        return node.docState === Number(job[stateKey]) && roleUuids.find(id => id === node.roleUuid)
      })
    }
  },
  watch: {
    job(newVal) {
      if (newVal) {
        this.getWorkFlow()
      }
    }
  },
  methods: {
    getWorkFlow() {
      const { documentConfigName, job, stateKey } = this
      getWorkFlow({ documentConfigName, uuid: job.uuid, state: job[stateKey] }).then(res => {
        this.workflowData = res.data.workflow
      })
    },
    handleClick(action) {
      const { stateKey } = this
      this.loading = getLoading('app-main-content')
      const params = {
        documentConfigName: this.documentConfigName,
        uuid: this.job.uuid,
        actionId: action.id,
        state: this.job[stateKey]
      }
      actionProcess(params).then(res => {
        this.getWorkFlow()
        this.$emit('success', this.job.uuid)
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style scoped>

</style>
